import React,{useState} from 'react'
import clinicService from '../../../../../services/clinic.service'
import {toast} from 'react-toastify'
import {useForm} from 'react-hook-form'


function AddLinksForm({clinicid,getLinks}) {

  const { register, handleSubmit, formState:{errors} } = useForm()
const onSubmit = (data)=>{
clinicService.addUpdateReputationLink(clinicid,data)
.then(res=>{
   // console.log(res.data)
    getLinks()
    toast.success("Added New Link",{
        position:toast.POSITION.BOTTOM_RIGHT
    })

})
.catch(err=>{
    toast.error("Error while Adding New Link",{
        position:toast.POSITION.BOTTOM_RIGHT
    })
})
}
  return (
   <div className="row">
    <div className="col-6">
    <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mb-2">
                      <select className='form-select' {...register("linkType")}>
                        <option value="FACEBOOK">Facebook</option>
                        <option value="WEBSITE">Website</option>
                        <option value="INSTAGRAM">Instagram</option>
                        <option value="GOOGLE">Google</option>
                        <option value="YELP">Yelp</option>

                      </select>
                    </div>
                    <div className="mb-2">
                    <label className="form-label">Url</label>
                    <input type="text" className="form-control" {...register("link")}/>
                    <input type="hidden" {...register("clinicId")} />
                    </div>
                    <div className="mb-2">
                        <label htmlFor="" className='form-label'>Notes:</label>
                        <input type="text" className="form-control" {...register("notes")}/>
                  
                    </div>
                    <div className="mb-2">
                        <label htmlFor="" className='form-label'>Extra Data:</label>
                        <input type="text" className="form-control" {...register("extraData")}/>
                  
                    </div>
                    <div className="mb-2">
                      <label htmlFor="" className='form-label'>Status</label>
                       <select className='form-select' {...register("isActive")}>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                       </select>
                    </div>
                    <div className="d-flex justify-content-between mb-3">
                                    <button type="submit" className="btn btn-primary btn-sm">Add</button>
                                          </div>
                </form>
    </div>

   </div>
  )
}

export default AddLinksForm